import { get } from 'lodash-es'
import { getImageBySize } from '~/composables/getImageBySize'

export default function getFirstImage(product, size = 'thumbnail') {
  const variants = get(product, 'product_images[0].image_data.variants')
  if (variants) {
    return getImageBySize(variants, size)
  }

  return null
}
